import { ISOPEN } from '../_constants';

export function expander() {
  $('.js-expander-head').on('click', function() {
    $(this).parent().find('.js-expander-content').slideToggle();
    $(this).parent().toggleClass(ISOPEN);
  });
}
